










































// import {addEmployee,queryEmployeeById,updateEmployee} from '@/api/employee'
import {addConsultant, queryConsultantById, updateConsultant, ResetConsultant} from '@/api/consultant'
import router from '@/router';
export default {
  data() {
    return {
      optType: '',//当前操作的类型，新增或者修改
      ruleForm: {
        name: '',
        username: '',
        sex: '1',
        phone: '',
        institution: '',
        orderNumber: 3
      },
      rules: {
        name: [
            { required: true, message: '请输入咨询师姓名', trigger: 'blur' }
        ],
        username: [
            { required: true, message: '请输入咨询师账号', trigger: 'blur' }
        ],
        phone: [
          { required: true, trigger: 'blur',validator: (rule,value,callback) => {
              if(value === '' || (!/^1(3|4|5|6|7|8)\d{9}$/.test(value))){
                callback(new Error('请输入正确的手机号！'))
              }else{
                callback()
              }
            } 
          }
        ],
        orderNumber: [
          { required: true, message: '请输入咨询师客单数', trigger: 'blur', validator: (rule,value,callback) => {
              if(value === '' || (!/^[0-9]*$/.test(value))){
                callback(new Error('请输入正确的客单数！'))
              }else{
                callback()
              }
            } 

          }
        ]
        
      }
    }
  },
  created() {
    //获取路由参数（id），如果有则为修改操作，否则为新增操作
    this.optType = this.$route.query.id ? 'update' : 'add'
    if(this.optType === 'update') {
      //修改操作，需要根据id查询员工信息用于页面回显
      queryConsultantById(this.$route.query.id).then(res => {
        if(res.data.code === 1){
          this.ruleForm = res.data.data
        }
      })
    }
  },
  methods: {
    submitForm(formName,isContinue){
      //进行表单校验
      this.$refs[formName].validate((valid) => {
        if(valid) {
          //表单校验通过，发起Ajax请求，将数据提交到后端
          if(this.optType === 'add'){//新增操作
            addConsultant(this.ruleForm).then((res) => {
                if(res.data.code === 1){
                  this.$message.success('咨询师添加成功！')
                  if(isContinue){
                  this.ruleForm = {
                    name: '',
                    username: '',
                    sex: '1',
                    phone: '',
                    institution: '',
                    orderNumber: 3
                    }
                  }else {
                    this.$router.push('/consultant')
                  }
                }else {
                  this.$message.error(res.data.msg)
                }
              })
          }else{//修改操作
            updateConsultant(this.ruleForm).then(res => {
              if(res.data.code === 1){
                this.$message.success('咨询师信息修改成功！')
                this.$router.push('/consultant')
              }
            })
          }
        }
      })
    },
    resetPwd(){
      ResetConsultant(this.$route.query.id).then(res =>{
        if(res.data.code === 1){
          this.$message.success('咨询师密码重置成功！')
        }
      })
    }

  }
}
